import { MatMomentDateAdapterOptions, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';

export class EnglishMomentDateAdapter extends MomentDateAdapter {
  // Ensures form values become English moment objects
  deserialize(value: any): moment.Moment | null {
    if (value) {
      const d = moment(value);
      return d.isValid() ? d.locale('en') : null;
    }
    return null;
  }

  // Controls what Angular returns as ISO format
  toIso8601(date: moment.Moment): string {
    return date
      .clone()
      .locale('en')
      .format('YYYY-MM-DD');
  }
  format(date: moment.Moment, displayFormat: string): string {
    // Calendar header formats are usually "MMM YYYY" or similar.
    // Detect them and format in Arabic:
    // const isCalendarLabel = displayFormat.includes('MMM') && displayFormat.includes('YYYY');
    // if (isCalendarLabel) {
    // Arabic for calendar UI
    // (Sobhy) I'll always return format in Arabic then I will change it into English before submitting the form
    // using momentFormatEn function in shared.service.ts
    return date.locale('ar').format(displayFormat);
    // }

    // English for input fields & model
    // return date.locale('en').format(displayFormat);
  }

  // format(date: moment.Moment, displayFormat: string): string {
  //   return date.locale('en').format(displayFormat);
  // }
  // What appears inside input fields (still English)
  //   override format(date: moment.Moment, displayFormat: string): string {
  //     if (!date.isValid()) return '';
  //     return date.clone().locale('en').format(displayFormat);
  //   }

  // Internal date creation
  //   override createDate(year: number, month: number, date: number): moment.Moment {
  //     return moment({ year, month, date }).locale('en');
  //   }
}
